export default "__VITE_ASSET__f0b65695__"